import { Injectable } from "@angular/core";
import { YoumAPIFacade } from "@youm-front/core";
import { map } from "rxjs/operators";
import {
  RoomAccountDeleteEventDTO,
  RoomAccountDeleteEventDTORaw,
  RoomAccountDeleteRequestDTO,
  RoomAccountDeleteRequestDTORaw
} from "../dto";

@Injectable()
export class RoomAccountService {
  constructor(private readonly youmAPIFacade: YoumAPIFacade) {}

  listenRoomAccountDelete() {
    return this.youmAPIFacade
      .listenRoomAccountDelete<RoomAccountDeleteEventDTORaw>()
      .pipe(map((_) => new RoomAccountDeleteEventDTO(_)));
  }

  roomAccountDelete(roomAccountDeleteRequestDTO: RoomAccountDeleteRequestDTO) {
    return this.youmAPIFacade
      .roomAccountDelete<void, RoomAccountDeleteRequestDTORaw>(
        roomAccountDeleteRequestDTO.data
      )
      .pipe(map(() => void 0));
  }
}
